import GeoBase, {IGeoParams} from './geo_base';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';
import {GEO_LOCATION} from './geo_consts';
import GeoDataFormatter from "./geo_data_formatter";

export default class GeoHybrid extends GeoBase
{
    static CLASS = 'GeoHybrid';

    public init(params:IGeoParams):void{
        super.init(params);
        Event.on(SYSTEM_EVENTS.GEO_HYBRID_GET_LOCATION_RES, this.onGeoLocationRes, this);
    }

    public getGeoLocation(getGeoLocation:GeoDataFormatter):Promise<void> {
        let data = getGeoLocation.getAllData();
        Event.fire(SYSTEM_EVENTS.GEO_HYBRID_GET_LOCATION, data);
        return Promise.resolve();
    }

    private onGeoLocationRes(allData:string):void {
        let jsonData;
        try {
            jsonData = JSON.parse(allData);
        } catch(e) {
            this.sendAnalytics("GeoLocation Results JSON damaged - Hybrid")
        }
       switch (jsonData.type) {
           case GEO_LOCATION.RES_OK:
               this.parent.onGeoLocationResOk(jsonData.data);
               break;
           case GEO_LOCATION.RES_FAILED:
               this.parent.onGeoLocationResFailed(600, jsonData.data);
               break;
           default:
               this.parent.onGeoLocationResFailed(600, '');
               break;
       }
    }
}